import { LiveStreamSettings } from "..";
import { SettingsAppV1Provider } from "../../SettingsAppV1Provider";

export const LiveStreamSettingsV1 = () => (
  <SettingsAppV1Provider>
    <LiveStreamSettings hideHeader />
  </SettingsAppV1Provider>
);
